import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Menu } from 'primereact/menu';
import React, { useEffect, useRef, useState } from 'react';

import DisputedIcon from '../../assets/DisputedIcon.svg';
import { metricValueFormat } from '../../utils/metricValueFormat';
import { DateTemplate } from '../dateTemplate/DateTemplate';
import MessageInfo from '../messageInfo/MessageInfo';
import { ResolveAgentDispute } from '../resolveAgentDispute/ResolveAgentDispute';
import './agentDisputeDetails.scss';
import { useGetScorecardAgentDisputeDetailsQuery } from './agentDisputeDetailsSlice';

type AgentDisputeDetailsProps = {
    agentNumber?: number;
    supervisorNumber?: number;
    scorecardVersion?: number;
    inputyear?: number;
    inputmonth?: number;
};

export const AgentDisputeDetails = ({
    agentNumber,
    supervisorNumber,
    scorecardVersion,
    inputyear,
    inputmonth,
}: AgentDisputeDetailsProps) => {
    const [metricColHeader, setMetricColHeader] = useState<any>([]);
    const [selecteDisputeRecords, setSelectedDisputeRecords] = useState<any>([]);
    const [agentDisputedData, setAgentDisputedData] = useState<any>([]);
    const [disputeDialogEnable, setDisputeDialogEnable] = useState<boolean>(false);
    const [selectedRowData, setSelectedRowData] = useState<any>([]);

    const { data: agentDisputesData, isFetching: agentDisputesDataFetching } =
        useGetScorecardAgentDisputeDetailsQuery(
            {
                employeenumber: agentNumber,
                supervisornumber: supervisorNumber,
                year: inputyear,
                month: inputmonth,
                scorecardversionid: scorecardVersion,
            },
            { skip: !agentNumber || !inputyear || !inputmonth || !scorecardVersion }
        );

    useEffect(() => {
        if (agentDisputesData?.data.length > 0) {
            agentDisputesData?.data.map((x: any) => {
                const obj = Object.keys(x?.agentDailyDisputes[0]?.disputeDetails);
                setMetricColHeader(obj);
                return obj;
            });
        }
        setAgentDisputedData(agentDisputesData?.data.length > 0 ? agentDisputesData.data : []);
    }, [agentDisputesData]);
    const onSelectionChange = (event: any) => {
        setSelectedDisputeRecords(event.value);
    };
    const metricsOneBodyTemplate = (rowData: any, props: any) => {
        const disputeDetails = rowData?.agentDailyDisputes[0]?.disputeDetails;
        const disputeDetail = disputeDetails?.[props?.column?.props.header];

        let metricValue = disputeDetail?.metric_value;
        const disputeStatus = disputeDetail?.dispute_status_id;
        const metricTypeName = disputeDetail?.metric_type_name;

        if (metricValue == null) {
            metricValue = '--';
        } else if (metricTypeName !== undefined) {
            metricValue = metricValueFormat(metricValue, metricTypeName);
        }

        const metricElement = (
            <span className={`image-text ${disputeStatus === 1 ? 'disputed' : ''}`}>{metricValue}</span>
        );

        return metricElement;
    };

    const metricsDisputedBodyTemplate = (rowData: any) => {
        const disputeDetails = rowData?.agentDailyDisputes[0]?.disputeDetails;
        const isDisputed = Object.values(disputeDetails).some((item: any) => item.dispute_status_id === 1);
    
        const metricElement = isDisputed ? (
            <img className="justify-content-left" src={DisputedIcon} alt="disputed" />
        ) : (
            <div />
        );
    
        return metricElement;
    };
    
    const menu = useRef<Menu>(null);
    const items = [];
    items.push({
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: () => {
            setDisputeDialogEnable(true);
        },
    });
    const popupMenuClickHandler = (e: any, rowData: any) => {
        e.preventDefault();
        menu.current?.toggle(e);
        setSelectedRowData(rowData);
    };
    const actionTemplate = (rowData: any) => {
       // if (rowData?.review_status_id !== 1) {  // 1=Needs Review, 2=Reviewed, 3=Disputed.  Condition removed per E20-5945.
            return (
                <div
                    onClick={(e: any) => {
                        popupMenuClickHandler(e, rowData);
                    }}
                    aria-controls="popup_menu"
                    aria-haspopup
                    aria-hidden="true"
                    style={{ cursor: 'pointer' }}
                >
                    <i className="pi pi-ellipsis-v mt-2 me-3" style={{ fontSize: '1.2em' }} />
                </div>
            );
        //}
    
        return <div />;
    };
    
    const closeResolveDisputes = (message: boolean) => {
        setDisputeDialogEnable(message);
    };
    if (agentDisputedData?.length > 0) {
        return (
            <div className="card mt-3 border-0">
                <Menu model={items} popup ref={menu} id="popup_menu" className="headerFeatures" />
                <ResolveAgentDispute
                    selectedRowDisputeDetails={selectedRowData}
                    disputeDialogEnable={disputeDialogEnable}
                    closeResolveDisputes={closeResolveDisputes}
                    agentNumber={agentNumber}
                    scorecardVersion={scorecardVersion}
                    inputyear={inputyear}
                    inputmonth={inputmonth}
                />
                <div className="card-header border-0" style={{ backgroundColor: '#ebf2f9', padding: '15px' }}>
                    Dispute Details
                </div>
                <div className="card-body tableContentCardBody">
                    <div>{agentDisputesDataFetching ? '<LoadingSpinner />' : ''}</div>
                    <div className="row">
                        <div className="col-md-12 p-0">
                            <DataTable
                                value={agentDisputedData}
                                className="p-datatable-customers p-0 agentDisputeDetails"
                                dataKey="id"
                                emptyMessage="No disputes found."
                                selection={selecteDisputeRecords}
                                onSelectionChange={onSelectionChange}
                            >
                                <Column
                                    header=""
                                    body={metricsDisputedBodyTemplate}
                                    style={{ width: '3%' }}
                                />
                                <Column
                                    header="Date"
                                    sortable
                                    sortField="metric_date"
                                    filterField="metric_date"
                                    body={(date: any) => DateTemplate(date?.metric_date)}
                                    field="metric_date"
                                    showFilterMatchModes={false}
                                    style={{ width: '10%' }}
                                />
                                {metricColHeader.map((metricHeader: any) => {
                                    return (
                                        <Column
                                            key={metricHeader}
                                            header={metricHeader}
                                            showFilterMatchModes={false}
                                            body={metricsOneBodyTemplate}
                                            style={{ width: '10%' }}
                                        />
                                    );
                                })}
                                <Column
                                    header="Status"
                                    sortable
                                    sortField="review_status_name"
                                    filterField="review_status_name"
                                    field="review_status_name"
                                    showFilterMatchModes={false}
                                    style={{ width: '10%' }}
                                />
                                <Column body={actionTemplate} style={{ width: '3%' }} />
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <div className="col-12">
            <MessageInfo title="" message="No disputes found." rowHeight="50px" />
        </div>
    );
};
